module.exports = __webpack_public_path__ + "img/lock.ee7ef693.png";